import React, { Component } from 'react'
import { sweetalert } from "../../App";
import Validator, { ValidationEntry } from "../../validation/Validator";
import { Validators } from "../../validation/Validators";
import Overlay from "../Overlay";
import { hideModal, buildRow, getLabel, getReactSelectAriaLabel, getLabelForState, getLabelForCounty, isPlacesAvailable } from "../../util/FormatUtil";
import InBetweenOverlay from "../InBetweenOverlay";
import Select from "react-select";
import PhoneInput from 'react-phone-number-input';
import SystemAPI from '../../network/SystemAPI';
import { withTranslation } from 'react-i18next';
import AutoComplete from '../admin/Autocomplete';
import { AuthContext } from '../../context/AuthContext';
import PatientAPI from '../../network/PatientAPI';


interface ParentInfoModalState {
  parentInfo?
  showLoading?
  showInBetween?
  relationships?
  useManualAddress?: boolean
}

interface ParentInfoModalProps {
  states?
  countries?
  gender?
  race?
  ethnicity?
  submit?
  t
  onClose?
  counties?
}

class ParentInfoModal extends Component<ParentInfoModalProps, ParentInfoModalState> {
  public static ID = "parentinfo";
  static contextType = AuthContext;

  constructor(props) {
    super(props)
    this.state = {
      showLoading: false,
      useManualAddress: false
    }
  }

  componentDidMount(): void {
    $(`#${ParentInfoModal.ID}`).on('shown.bs.modal', function () {
      $(document).off('focusin.modal');
    });
    //@ts-ignore
    SystemAPI.getAllRelationships().then(data => {
      this.setState({ relationships: data })
    })
    PatientAPI.getUserProfileByUID(this.context.uid).then(response => {
      let profileData = response.data[0];
      this.setState({
        parentInfo: {
          ParentFirstName: profileData && profileData.firstName ? profileData.firstName : null,
          ParentMiddleInitial: profileData && profileData.middleName ? profileData.middleName : null,
          ParentLastName: profileData && profileData.lastName ? profileData.lastName : null,
          ParentEmail: profileData && profileData.email ? profileData.email : this.context.email,
          ParentPhone: profileData && profileData.phoneNumber ? profileData.phoneNumber : null,
          ParentAddress: profileData && profileData.streetAddress ? profileData.streetAddress : null,
          ParentCity: profileData && profileData.city ? profileData.city : null,
          // Default to Oklahoma ('OK') when no state is saved on the profile — this is an
          // Oklahoma exemption platform, so it keeps State/County consistent and pre-filters
          // the county list to OK. Users can still change it for out-of-state addresses.
          ParentState: profileData && profileData.state ? profileData.state : 'OK',
          ParentZip: profileData && profileData.zipcode ? profileData.zipcode : null,
          ParentCounty: profileData && profileData.county ? profileData.county : null,
          textOptOut: profileData && profileData.TextOptOut ? profileData.TextOptOut : false,
          RelationshipID: null // not stored in our PatientProfile table
        },
        // A prefilled address is only visible in manual mode: the Google search box always
        // renders empty, so in autocomplete mode the parent would see nothing while the
        // prefilled values still passed validation and got submitted unconfirmed. Open in
        // manual mode whenever the profile already has an address so it is always on screen.
        useManualAddress: !!(profileData && profileData.streetAddress),
        showLoading: false
      }); // set state profile
    })
  }

  /**
   * Google reports a resolved address only through its place_changed event, so free text
   * typed into the search box never updates ParentAddress/City/Zip/County. Clearing those
   * here stops an edited search string from silently submitting the previously resolved
   * (or profile-prefilled) address — validateParent flags the blanks instead.
   * ParentState is deliberately left alone so the 'OK' default and its county filtering survive.
   */
  handleAddressSearchChange(addr) {
    this.setState((prevState) => ({
      parentInfo: {
        ...prevState.parentInfo,
        SearchAddress: addr,
        ParentAddress: null,
        ParentCity: null,
        ParentZip: null,
        ParentCounty: null
      }
    }))
  }

  /** Readable summary of the address that will actually be submitted, or null if none is set. */
  getResolvedAddressSummary() {
    let info = this.state.parentInfo;
    if (!info || !info.ParentAddress) { return null }
    let stateLabel = getLabelForState(info.ParentState, this.props.states, this.props.t);
    return [
      info.ParentAddress,
      info.ParentCity,
      stateLabel && stateLabel.label ? stateLabel.label : info.ParentState,
      info.ParentZip,
      info.ParentCounty ? `${info.ParentCounty} ${this.props.t('County')}` : null
    ].filter(Boolean).join(', ');
  }

  validateParent(parentInfo) {
    let patientFormValidation = {
      FirstName: parentInfo?.ParentFirstName,
      MiddleInitial: parentInfo?.ParentMiddleInitial,
      LastName: parentInfo?.ParentLastName,
      Address: parentInfo?.ParentAddress,
      City: parentInfo?.ParentCity,
      State: parentInfo?.ParentState,
      Zipcode: parentInfo?.ParentZip,
      County: parentInfo?.ParentCounty,
      Email: parentInfo?.ParentEmail,
      Phone: parentInfo?.ParentPhone,
      Relationship: parentInfo?.RelationshipID
    };

    let validator = new Validator<any>()
      .withSimpleValidation("FirstName", Validators.requireNonNullValidator("First Name"))
      .withSimpleValidation("LastName", Validators.requireNonNullValidator("Last Name"))
      .withSimpleValidation("Relationship", Validators.requireNonNullValidator("Relationship"))
      .withSimpleValidation("Address", Validators.requireNonNullValidator())
      .withSimpleValidation("City", Validators.requireNonNullValidator())
      .withSimpleValidation("State", Validators.requireNonNullValidator())
      .withSimpleValidation("Zipcode", Validators.requireNonNullValidator())
      .withSimpleValidation("County", Validators.requireNonNullValidator())
      .withComposedValidation("Email", new ValidationEntry(Validators.requireValidEmail("Email")), Validators.requireNotBlankAndLength(100, "Email"))
      .withComposedValidation("Phone", new ValidationEntry(Validators.requireNonNullValidator("Phone")), new ValidationEntry(Validators.requirePhone("Phone")))
    let validationResponse = validator.validate(patientFormValidation);
    if (!validationResponse.success) {
      return { success: false, error: validationResponse.error }
    } else {
      return { success: true }
    }
  }

  handleSave() {
    this.setState({ showLoading: true })

    let tempDate = this.state.parentInfo ? this.state.parentInfo.ParentDOB : null;

    let parentInfoCopy = this.state.parentInfo ? JSON.parse(JSON.stringify(this.state.parentInfo)) : null
    if (parentInfoCopy) {
      parentInfoCopy.ParentFirstName = parentInfoCopy && parentInfoCopy.ParentFirstName ? parentInfoCopy.ParentFirstName.trim() : null
      parentInfoCopy.ParentMiddleInitial = parentInfoCopy && parentInfoCopy.ParentMiddleInitial ? parentInfoCopy.ParentMiddleInitial.trim() : null
      parentInfoCopy.ParentLastName = parentInfoCopy && parentInfoCopy.ParentLastName ? parentInfoCopy.ParentLastName.trim() : null
      parentInfoCopy.ParentAddress = parentInfoCopy.ParentAddress ? parentInfoCopy.ParentAddress.trim() : null
      parentInfoCopy.ParentAdditionalAddressInfo = parentInfoCopy.ParentAdditionalAddressInfo ? parentInfoCopy.ParentAdditionalAddressInfo.trim() : null
      parentInfoCopy.ParentCity = parentInfoCopy.ParentCity ? parentInfoCopy.ParentCity.trim() : null
      parentInfoCopy.ParentZip = parentInfoCopy.ParentZip ? parentInfoCopy.ParentZip.trim() : null
      parentInfoCopy.ParentCounty = parentInfoCopy.ParentCounty ? parentInfoCopy.ParentCounty.trim() : null
      parentInfoCopy.ParentState = parentInfoCopy.ParentState ? parentInfoCopy.ParentState.trim() : null
      parentInfoCopy.ParentEmail = parentInfoCopy.ParentEmail ? parentInfoCopy.ParentEmail.trim() : null
      parentInfoCopy.ParentPhone = parentInfoCopy.ParentPhone ? parentInfoCopy.ParentPhone.trim() : null

      delete parentInfoCopy.SearchAddress
    }

    this.setState({ parentInfo: parentInfoCopy })

    //validate patient info
    let res = this.validateParent(parentInfoCopy)
    if (!res.success) {
      this.setState({ showLoading: false })
      return sweetalert.fire({
        icon: "error",
        title: "",
        text: this.props.t(res.error),
      });
    } else {
      //pass back to parent
      this.props.submit(parentInfoCopy)

      hideModal(ParentInfoModal.ID)
      this.setState({ showLoading: false })
    }


  }
  render() {

    let translationRelationships = this.state.relationships && this.state.relationships.length > 0 ? this.state.relationships.map(e => { return { label: this.props.t(e.label), value: e.value } }) : [];
    return (
      <React.Fragment>
        <Overlay show_loading={this.state.showLoading} zIndex={100005} />
        <InBetweenOverlay showInBetween={this.state.showInBetween} zIndex={100003} />
        <div className="modal fade form_modal" id={ParentInfoModal.ID} tabIndex={-1} role="dialog"
          aria-hidden="true">
          <div className="modal-dialog modal-lg modal-xl col-8 px-0" role="document">
            <div className="modal-content">
              <div className="modal-body p-0 m-0">
                <div className="container-fluid">
                  <div className={"row"}>
                    <div className="col-12 pt-2">
                      <div className="card mt-2">
                        <div className="card-header verlag-bold">
                          <div className="row">
                            <div className="col-10">
                              <h4>
                                {this.props.t("Parent/ Guardian Information")}
                              </h4>
                            </div>
                            <div className="col-2">
                              <button style={{ outline: 'none' }} type="button" className="close"
                                aria-label={this.props.t("Close")} onClick={() => { hideModal(ParentInfoModal.ID); this.props.onClose() }}>
                                <span aria-hidden="true" style={{ fontSize: '1.5em', fontWeight: 'bold' }}>&times;</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="card-body">
                          {buildRow(this.props.t('First Name'),
                            <input
                              id={'ParentFirstName'}
                              className={"form-control"}
                              maxLength={50}
                              autoComplete={"off"}
                              type={"search"}
                              name={'ParentFirstName'}
                              aria-label={this.props.t("First Name Of Parent")}
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  parentInfo: {
                                    ...prevState.parentInfo,
                                    ParentFirstName: e.target.value
                                  }
                                }))
                              }}
                              value={this.state.parentInfo?.ParentFirstName}
                            />, this.props.t('First Name Of Parent')
                            , true
                          )}
                          {buildRow(this.props.t('Middle Initial'),
                            <input
                              id={'ParentMiddleInitial'}
                              className={"form-control"}
                              maxLength={50}
                              autoComplete={"off"}
                              type={"search"}
                              name={'ParentMiddleInitial'}
                              aria-label={this.props.t("Middle Initial Of Parent")}
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  parentInfo: {
                                    ...prevState.parentInfo,
                                    ParentMiddleInitial: e.target.value
                                  }
                                }))
                              }}
                              value={this.state.parentInfo?.ParentMiddleInitial}
                            />, this.props.t('Middle Initial Of Parent')
                          )}
                          {buildRow(this.props.t('Last Name'),
                            <input
                              id={'ParentLastName'}
                              className={"form-control"}
                              maxLength={50}
                              autoComplete={"off"}
                              type={"search"}
                              name={'ParentLastName'}
                              aria-label={this.props.t("Last Name Of Parent")}
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  parentInfo: {
                                    ...prevState.parentInfo,
                                    ParentLastName: e.target.value
                                  }
                                }))
                              }}
                              value={this.state.parentInfo?.ParentLastName}
                            />, this.props.t('Last Name Of Parent')
                            , true
                          )}
                          {buildRow(this.props.t('Relationship'),
                            <Select
                              key={'Relationship'}
                              id={'Relationship'}
                              isSearchable={true}
                              placeholder={<div className="accessibilityText">{this.props.t("Please Select...")}</div>}
                              noOptionsMessage={() => this.props.t("No option")}
                              aria-label={getReactSelectAriaLabel("Relationship", this.state.parentInfo ? getLabel(this.state.parentInfo.RelationshipID, this.state.relationships, this.props.t) : null, this.props.t)}
                              value={this.state.parentInfo ? getLabel(this.state.parentInfo.RelationshipID, this.state.relationships, this.props.t) : null}
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  parentInfo: {
                                    ...prevState.parentInfo,
                                    RelationshipID: e.value
                                  }
                                }))
                              }}
                              className={'state_select'}
                              options={translationRelationships}
                            />, this.props.t('Relationship to Child')
                            , true
                          )}
                          {/* Address Section with Toggle */}
                          <div key={"ParentAddressToggle"} className="form-group row" data-toggle={'tooltip'} data-placement={'top'} title={this.props.t('Address')}>
                            {/* htmlFor tracks the mode: the autocomplete input is not rendered in manual
                                mode, so a fixed target would leave the label unassociated half the time. */}
                            <label id={'AddressLabel'} htmlFor={this.state.useManualAddress ? 'StreetAddress' : 'Parentautocomplete'} className="col-12 col-sm-4 col-form-label px-3">
                              {this.props.t('Address')}<section className="text-danger d-inline-block px-1">*</section>
                            </label>
                            {/* Manual mode renders five controls, so the group — not just the first input —
                                is what the label names. role/aria-labelledby announces that correctly. */}
                            <div className="col-12 col-sm-8 p-0 m-0" role="group" aria-labelledby={'AddressLabel'}>
                              {/* No toggle when Places is unavailable — there is nothing to switch to,
                                  and manual entry is already the only mode being rendered. */}
                              {isPlacesAvailable() &&
                              <div className="d-flex justify-content-end mb-1 px-2">
                                <button
                                  type="button"
                                  className="btn btn-link text-muted p-0"
                                  style={{ fontSize: '0.9rem' }}
                                  aria-pressed={this.state.useManualAddress}
                                  onClick={() => this.setState(prev => ({ useManualAddress: !prev.useManualAddress }))}
                                >
                                  {!this.state.useManualAddress ? this.props.t('Enter Manually') : this.props.t('Search Address')}
                                </button>
                              </div>
                              }

                              {/* isPlacesAvailable is re-evaluated on every render, so this self-corrects
                                  once the async Maps script finishes loading. */}
                              {!this.state.useManualAddress && isPlacesAvailable() ? (
                                /* Google Places Autocomplete Mode */
                                <React.Fragment>
                                <AutoComplete key={"Parentautocomplete"} id={"Parentautocomplete"}
                                  onChange={(addr) => this.handleAddressSearchChange(addr)}
                                  value={this.state.parentInfo?.SearchAddress}
                                  updateFormData={(addr, city, state, zip, county, country) => {
                                    this.setState({
                                      parentInfo: { ...this.state.parentInfo, ParentAddress: addr, ParentCity: city, ParentState: state, ParentZip: zip, ParentCounty: county }
                                    })
                                  }}
                                />
                                {/* The search box only shows what was typed, not what was resolved.
                                    Echo the address that will actually be submitted so the parent can
                                    always see and confirm it before saving. */}
                                {this.getResolvedAddressSummary() &&
                                  <div className="px-2 pt-2 text-muted" style={{ fontSize: '0.9rem' }} aria-live="polite">
                                    {this.props.t('Address to be submitted')}: {this.getResolvedAddressSummary()}
                                  </div>
                                }
                                </React.Fragment>
                              ) : (
                                /* Manual Address Entry Mode */
                                <div className="px-2">
                                  {/* Visible labels, not just placeholders: a placeholder disappears once the
                                      field has a value, leaving a filled form with unlabelled boxes (WCAG 3.3.2). */}
                                  <div className="mb-2">
                                    <label htmlFor={'StreetAddress'} className="mb-0 small text-muted">{this.props.t("Street Address")}</label>
                                    <input
                                      id={'StreetAddress'}
                                      className={"form-control"}
                                      maxLength={50}
                                      autoComplete={"off"}
                                      type={"search"}
                                      name={'StreetAddress'}
                                      placeholder={this.props.t("Street Address")}
                                      aria-label={this.props.t("Street Address")}
                                      onChange={(e) => {
                                        this.setState((prevState) => ({
                                          parentInfo: {
                                            ...prevState.parentInfo,
                                            ParentAddress: e.target.value
                                          }
                                        }))
                                      }}
                                      value={this.state.parentInfo?.ParentAddress}
                                    />
                                  </div>
                                  <div className="mb-2">
                                    <label htmlFor={'City'} className="mb-0 small text-muted">{this.props.t("City")}</label>
                                    <input
                                      id={'City'}
                                      className={"form-control"}
                                      maxLength={50}
                                      autoComplete={"off"}
                                      type={"search"}
                                      name={'City'}
                                      placeholder={this.props.t("City")}
                                      aria-label={this.props.t("City")}
                                      onChange={(e) => {
                                        this.setState((prevState) => ({
                                          parentInfo: {
                                            ...prevState.parentInfo,
                                            ParentCity: e.target.value
                                          }
                                        }))
                                      }}
                                      value={this.state.parentInfo?.ParentCity}
                                    />
                                  </div>
                                  <div className="row mb-2">
                                    <div className="col-6">
                                      {/* inputId, not id: react-select puts id on the wrapper, so htmlFor must
                                          target the inner input for the label to associate. */}
                                      <label htmlFor={'StateSelectInput'} className="mb-0 small text-muted">{this.props.t("State")}</label>
                                      <Select
                                        key={'State'}
                                        id={'State'}
                                        inputId={'StateSelectInput'}
                                        isSearchable={true}
                                        placeholder={<div className="accessibilityText">{this.props.t("State")}</div>}
                                        noOptionsMessage={() => this.props.t("No option")}
                                        aria-label={this.props.t("State")}
                                        value={this.state.parentInfo ? getLabelForState(this.state.parentInfo.ParentState, this.props.states, this.props.t) : null}
                                        onChange={(e) => {
                                          this.setState((prevState) => ({
                                            parentInfo: {
                                              ...prevState.parentInfo,
                                              ParentState: e.value,
                                              // A county belongs to exactly one state, so it cannot survive a state
                                              // change. Left set, getLabelForCounty returns null and the raw-county
                                              // fallback below re-displays it as a valid selection, and it passes
                                              // validateParent onto the exemption record.
                                              ParentCounty: null
                                            }
                                          }))
                                        }}
                                        className={'state_select'}
                                        options={this.props.states}
                                      />
                                    </div>
                                    <div className="col-6">
                                      <label htmlFor={'Zipcode'} className="mb-0 small text-muted">{this.props.t("Zipcode")}</label>
                                      <input
                                        id={'Zipcode'}
                                        className={"form-control"}
                                        maxLength={10}
                                        autoComplete={"off"}
                                        type={"search"}
                                        name={'Zipcode'}
                                        placeholder={this.props.t("Zipcode")}
                                        aria-label={this.props.t("Zipcode")}
                                        onChange={(e) => {
                                          this.setState((prevState) => ({
                                            parentInfo: {
                                              ...prevState.parentInfo,
                                              ParentZip: e.target.value
                                            }
                                          }))
                                        }}
                                        value={this.state.parentInfo?.ParentZip}
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-2">
                                    <label htmlFor={'CountySelectInput'} className="mb-0 small text-muted">{this.props.t("County")}</label>
                                    <Select
                                      key={`county-select-${this.state.parentInfo?.ParentState ? (typeof this.state.parentInfo?.ParentState === 'object' ? this.state.parentInfo?.ParentState.value : this.state.parentInfo.ParentState) : 'no-state'}`}
                                      id={'County'}
                                      inputId={'CountySelectInput'}
                                      isSearchable={true}
                                      placeholder={<div className="accessibilityText">{this.props.t("County")}</div>}
                                      noOptionsMessage={() => this.props.t("No option")}
                                      aria-label={this.props.t("County")}
                                      value={this.state.parentInfo
                                ? (getLabelForCounty(this.state.parentInfo.ParentCounty, this.props.counties, this.state.parentInfo.ParentState, this.props.states, this.props.t)
                                    // Fall back to the raw selected county when no state is set yet
                                    // (getLabelForCounty can't resolve a county without a state).
                                    // Normalize to a string first: ParentCounty may be an object ({ answer }).
                                    ?? (() => {
                                        const rawCounty = typeof this.state.parentInfo.ParentCounty === 'object'
                                          ? this.state.parentInfo.ParentCounty?.answer
                                          : this.state.parentInfo.ParentCounty;
                                        return rawCounty
                                          ? { label: this.props.t(rawCounty), value: rawCounty }
                                          : null;
                                      })())
                                : null}
                                      options={this.state.parentInfo?.ParentState
                                        ? this.props.counties.filter(c => {
                                          const stateValue = typeof this.state.parentInfo.ParentState === 'object'
                                            ? this.state.parentInfo.ParentState.value
                                            : this.state.parentInfo.ParentState;
                                          const stateName = this.props.states.find(s => s.value === stateValue)?.label;
                                          return c.value === stateName || c.originalValue === stateName;
                                        }).map(c => ({
                                          label: c.label,
                                          value: c.label,
                                          originalValue: c.value
                                        }))
                                        : this.props.counties.map(c => ({
                                          label: c.label,
                                          value: c.label,
                                          originalValue: c.value
                                        }))
                                      }
                                      filterOption={(option, input) => {
                                        const label = option.label?.toString().toLowerCase() || '';
                                        const search = input.toLowerCase();
                                        return label.includes(search);
                                      }}
                                      onChange={(e) => {
                                        this.setState((prevState) => ({
                                          parentInfo: {
                                            ...this.state.parentInfo,
                                            ParentCounty: e.label
                                          },
                                        }))
                                      }}
                                      className={'state_select'}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          {buildRow(this.props.t('Apartment/Suite/Building #'),
                            <input
                              id={'SecondaryAddressLine'}
                              className={"form-control"}
                              maxLength={50}
                              autoComplete={"off"}
                              type={"search"}
                              name={'SecondaryAddressLine'}
                              aria-label={this.props.t("Apartment/Suite/Building #")}
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  parentInfo: {
                                    ...prevState.parentInfo,
                                    ParentAdditionalAddressInfo: e.target.value
                                  }
                                }))
                              }}
                              value={this.state.parentInfo?.ParentAdditionalAddressInfo}
                            />, this.props.t('Apartment/Suite/Building #')
                          )}
                          {buildRow(this.props.t('Email'),
                            <input
                              id={'ParentEmail'}
                              className={"form-control"}
                              maxLength={100}
                              autoComplete={"off"}
                              type={"search"}
                              name={'ParentEmail'}
                              placeholder='name@example.com'
                              aria-label={'Email'}
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  parentInfo: {
                                    ...prevState.parentInfo,
                                    ParentEmail: e.target.value
                                  }
                                }))
                              }}
                              value={this.state.parentInfo?.ParentEmail}
                            />, this.props.t('Parent Email')
                            , true
                          )}
                          {buildRow(this.props.t('Cell Phone'),
                            <>
                              <PhoneInput
                                id={'ParentPhone'}
                                placeholder={this.props.t("Enter phone number (10 digit)")}
                                onChange={(e) =>
                                  this.setState((prevState) => ({
                                    parentInfo: {
                                      ...prevState.parentInfo,
                                      ParentPhone: e
                                    }
                                  }))}
                                defaultCountry="US"
                                aria-label={this.props.t("Cell Phone")}
                                value={this.state.parentInfo?.ParentPhone} />
                              <p className='text-center'>{this.props.t("You will receive a text about the status of your immunization exemption submission")}</p>
                            </>
                            , this.props.t('Cell Phone')
                            , true
                          )}
                          <div className="form-check text-center">
                            <input className="form-check-input" type="checkbox" id="optOut"
                              checked={this.state.parentInfo?.textOptOut ? true : false}
                              onChange={(e) =>
                                this.setState((prevState) => ({
                                  parentInfo: {
                                    ...prevState.parentInfo,
                                    textOptOut: e.target.checked
                                  }
                                }))} />
                            <label className="form-check-label" htmlFor="optOut">
                              {this.props.t('Opt out of text messages about the status of my immunization exemption submission.')}
                            </label>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer" style={{ backgroundColor: 'transparent', borderTop: 'none' }}>
                    <p className='d-inline-block'><section className="text-danger d-inline-block px-1">*</section>{this.props.t("Required Fields")}</p>
                    <button className={"btn btn-primary float-right mb-3"} onClick={() => this.handleSave()}>{this.props.t("Save")}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}


export default withTranslation()(ParentInfoModal);